module.exports = __webpack_public_path__ + "static/pic11.616f5381.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic11.jpg
// module id = 132
// module chunks = 35783957827783 123315765418214